import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import { setError } from '../common/toast/toast';
import imagemAdd from '../assets/images/icone_add_imagem.png';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import consts from '../consts';
import ImagemZoom from '../common/imagemZoom/ImagemZoom';

import {
	setModoTela, initForm, getListaArea, getListaPergunta, salvarCheklistResposta, salvarCheklistStatus
} from './checklistRespostaActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndRadioButtom from '../common/form/labelAndRadioButtom';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import InputAssinatura from '../common/form/inputAssinatura';

class ChecklistRespostaForm extends Component {

	state = {
		posicaoArea: 0,
		funcaoSalvarFile: () => {}
	}

    componentWillMount() {

		let initImageSeletor = () => {
			const imageSelector = document.createElement('input');
			imageSelector.setAttribute('type', 'file');
			imageSelector.setAttribute('multiple', true);
			imageSelector.addEventListener("change", async (data) => {

				let files = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files : [];
				if (!files.length) {
					files = data && data.target && data.target.files && data.target.files[0] ? data.target.files : [];
				}

				const fileArray = Array.from(files);

				if (!fileArray.length) {
					setError('Nenhuma imagem selecionada');
					initImageSeletor();
					return;
				}

				if (fileArray.filter(file => {
					if (!file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						return true;
					}
					return false;
				}).length) {
					setError('Selecione apenas (.PNG, .JPG e .JPEG)');
					initImageSeletor();
					return;
				}

				const quality = 0.7;
				const maxWidth = 1280;

				const readers = fileArray.map((file) => {
					return new Promise((resolve, reject) => {
						const reader = new FileReader();
						reader.onload = (event) => {
							const img = new Image();
							img.src = event.target.result;
							img.onload = () => {
								const canvas = document.createElement('canvas');
								const ctx = canvas.getContext('2d');
		
								// Definir tamanho proporcional
								let width = img.width;
								let height = img.height;
								if (width > maxWidth) {
									height *= maxWidth / width;
									width = maxWidth;
								}
		
								canvas.width = width;
								canvas.height = height;
								ctx.drawImage(img, 0, 0, width, height);
		
								// Converter para Base64 com compressão
								canvas.toBlob((blob) => {
									const reader = new FileReader();
									reader.readAsDataURL(blob);
									reader.onloadend = () => resolve(reader.result);
								}, 'image/jpeg', quality);
							};

						};
						reader.onerror = (error) => reject(error);
						reader.readAsDataURL(file);
					});
				});

				Promise.all(readers).then((results) => {
					this.state.funcaoSalvarFile(results);
					initImageSeletor();
				}).catch((error) => {
					console.error('Erro ao ler os arquivos:', error);
					initImageSeletor();
				});

			});

			this.imageSelector = imageSelector;

		}

		initImageSeletor();

		let initFileSeletor = () => {
			const fileSelector = document.createElement('input');
			fileSelector.setAttribute('type', 'file');
			fileSelector.setAttribute('multiple', true);
			fileSelector.addEventListener("change", (data) => {

				let files = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files : [];
				if (!files.length) {
					files = data && data.target && data.target.files && data.target.files[0] ? data.target.files : [];
				}

				const fileArray = Array.from(files);

				if (!fileArray.length) {
					setError('Nenhum arquivo selecionado');
					initFileSeletor();
					return;
				}

				if (fileArray.filter(file => {
					if (!file.type.includes('application/pdf')
						&& !file.type.includes('image/png') 
						&& !file.type.includes('image/jpg') 
						&& !file.type.includes('image/jpeg')
						&& !file.type.includes('video/mp4')
						&& !file.type.includes('video/avi')
						&& !file.type.includes('video/mpeg')
						&& !file.type.includes('video/quicktime')
						&& !file.type.includes('application/vnd.ms-excel') // .xls
						&& !file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') // .xlsx
						&& !file.type.includes('application/msword') // .doc
						&& !file.type.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document') // .docx
						&& !file.type.includes('application/vnd.ms-powerpoint') // .ppt
						&& !file.type.includes('application/vnd.openxmlformats-officedocument.presentationml.presentation') // .pptx
					) {
						return true;
					}
					return false;
				}).length) {
					setError('Selecione apenas (PDF, PNG, JPG e JPEG, MP4, AVI, MPEG, MOV, Excel, Word, PowerPoint)');
					initFileSeletor();
					return;
				}

				const readers = fileArray.map((file) => {
					return new Promise((resolve, reject) => {
						const reader = new FileReader();
						reader.onloadend = () => {
							resolve(reader.result);
						};
						reader.onerror = (error) => reject(error);
						reader.readAsDataURL(file);
					});
				});
	
				Promise.all(readers).then((results) => {
					this.state.funcaoSalvarFile(results);
					initFileSeletor();
				}).catch((error) => {
					console.error('Erro ao ler os arquivos:', error);
					initFileSeletor();
				});
			});

			this.fileSelector = fileSelector;

		}

		initFileSeletor();
	}

	componentDidMount = () => {

		let checklistResposta = this.props.formularioValues || {};
		this.props.getListaArea(checklistResposta.id_checklist);
		this.props.getListaPergunta(checklistResposta.id_checklist);

		this.setState({
			...this.state,
			checklistResposta: { ...checklistResposta }
		});
	}

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		// const usuarioLogado = this.props.usuarioLogado || {};
		// let checklist = this.props.route.params.checklist || {};
		
		let { listaArea, listaPergunta } = this.props;

		let anterior = false;
		let proximo = false;

		const styles = {
			scrolldivInicial: {
				flexGrow: 1,
				justifyContent: 'center',
				padding: 40
			},
			textMensagemInicial: {
				textAlign: 'center',
				fontSize: 16,
				marginBottom: 20
			},
			touchableOpacityCard: {
				marginTop: 8
			},
			viewArea: {
				borderWidth: 2,
				borderColor: '#f57215',
				borderRadius: 4,
				marginBottom: 12
			},
			viewAreaHeader: {
				padding: 8
			},
			viewSubAreaHeader: {
				padding: 8,
				backgroundColor: '#f59551'
			},
			viewAreaHeaderdiv: {
				padding: 8,
				fontSize: 16,
				fontWeight: 'bold'
			},
			viewPerguntas: {
				padding: 8
			},
			viewPerguntaHeader: {
				fontSize: 18,
				fontWeight: 'bold',
				marginTop: 8
			},
			textInputData: {
				width: 150,
				
			},
			viewButtons: {
				padding: 16
			},
			viewButtonAcoes: {
				display: 'flex',
				flexDirection: 'row',
				flex: 2,
				marginBottom: 40
			},
			buttonAcao: {
				flex: 1,
				marginTop: 12,
				marginRight: 4,
				marginLeft: 4
			},
		};

		const colors = {
			background: '#fff',
			backgroundFont: '#1e0805',
			primary: '#231f20',
			primaryDark: '#030303',
			primaryFont: '#fff',
			accent: '#f57215',
			accentLight: '#fa9e5c',
			accentFont: '#fff',
			font: '#03260f',
			danger: '#d32f2f'
		};
		const font = {
			color: colors.font,
			fontSize: 16
		};
		const viewAccent = {
			backgroundColor: colors.accent
		};
		const fontAccent = {
			color: colors.accentFont
		};
		const textInput = {
			color: colors.backgroundFont,
			backgroundColor: colors.background,
			marginBottom: 12
		};
		const buttonCadastroAcaoPrimary = {
			flex: 2,
			backgroundColor: colors.primary,
			color: colors.font,
			marginTop: 12,
			marginRight: 4
		};
		
		let contadorPosicoes = -1;
		listaArea = listaArea.map(item => {			
			//Só contábiliza na área e não na subárea
			if (!item.id_pai) {
				contadorPosicoes++;
			}

			return {
				...item,
				posicaoArea: contadorPosicoes
			};
		});

		return (
			<ContentCard>

				{this.fotoExpandida()}

				<ContentCardHeader>
					<Row alignCenter>
						<Grid cols='3 3 3 3'>
							<Button
								type={'primary'}
								text={'Ir para o Fim'}
								style={{ ...buttonCadastroAcaoPrimary, ...styles.buttonAcao }}
								event={() => {
									window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>

				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						{listaArea.filter(area => area.posicaoArea == this.state.posicaoArea).map(area => {

							anterior = area.id != listaArea[0].id;
							proximo = area.id != listaArea[listaArea.length - 1].id;

							const subArea = area.id_pai != null;
							
							return (
								<div key={area.id} style={{ ...styles.viewArea }}>
									<div style={!subArea ? { ...viewAccent, ...styles.viewAreaHeader } : { ...viewAccent, ...styles.viewSubAreaHeader }}>
										{subArea &&
										<div style={{ ...fontAccent, ...styles.viewAreaHeaderdiv, fontSize: 12 }}>Subárea</div>}

										<div style={{ ...fontAccent, ...styles.viewAreaHeaderdiv }}>{area.nome}</div>										
									</div>

									<div style={{ ...styles.viewPerguntas }}>
										{listaPergunta.filter(pergunta => pergunta.id_area == area.id).filter(pergunta => {
											return (this.state.checklistResposta ? this.state.checklistResposta.itens || [] : []).filter(itemResposta => itemResposta.id_item == pergunta.id).length;
										}).map(pergunta => {

											let resposta = (this.state.checklistResposta ? this.state.checklistResposta.itens : []).filter(itemResposta => itemResposta.id_item == pergunta.id)[0];

											let respostaPai = (this.state.checklistResposta ? this.state.checklistResposta.itens : []).filter(itemResposta => itemResposta.id_item == pergunta.id_pai)[0];

											if (pergunta.id_pai && (!respostaPai || pergunta.pai_condicao != respostaPai.resposta)) {
												return null;
											}

											let atualizarSimples = (value) => {

												this.setState({
													...this.state,
													checklistResposta: {
														...this.state.checklistResposta,
														itens: this.state.checklistResposta.itens.map(item => {
															if (item.id == resposta.id) {
																return {
																	...item,
																	resposta: value
																}
															} else {
																return item;
															}
														})
													}
												});
											}

											let atualizarMulti = (value) => {	

												this.setState({
													...this.state,
													checklistResposta: {
														...this.state.checklistResposta,
														itens: this.state.checklistResposta.itens.map(item => {
															if (item.id == resposta.id) {

																let respostaAux = (resposta.resposta || []).map(respAux => respAux);
																if (respostaAux.includes(value)) {
																	respostaAux = respostaAux.filter(opcao => opcao != value);
																} else {
																	respostaAux.push(value);
																}

																return {
																	...item,
																	resposta: respostaAux
																}
															} else {
																return item;
															}
														})
													}
												});
											}

											return (
												<div key={pergunta.id}>
													<div style={{ }}>
														<div style={{ ...font, ...styles.viewPerguntaHeader }}>{pergunta.descricao} {pergunta.obrigatorio ? '*' : ''}</div>
													</div>

													{pergunta.imagem &&
													<Row>
														<Grid cols='12 12 12 12'>
															<div
																style={{
																	display: 'flex',
																	flexDirection: 'row',
																	alignItems: 'center',
																	marginBottom: 12,
																	marginTop: 12,
																	marginLeft: 8,
																	marginRight: 8
																}}>
																<span class="btn btn-outline-secondary fileinput-button dz-clickable">
																	<img src={`${consts.URL}/${pergunta.imagem}`} 
																		style={{
																			width: '100%',
																			maxWidth: 800,
																			maxHeight: 800
																		}} />
																</span>
															</div>
														</Grid>
													</Row>}

													{this.props.formularioValues.edicaoRelatorio &&
													<div style={{ paddingTop: 8 }}>
														<LabelAndCheckbox
															mode='outlined'
															label={'Imprimir no relatório'}
															placeholder='Imprimir no relatório'
															value={resposta.imprime_relatorio}
															onChange={text => {
																this.setState({
																	...this.state,
																	checklistResposta: {
																		...this.state.checklistResposta,
																		itens: this.state.checklistResposta.itens.map(item => {
																			if (item.id == resposta.id) {
																				return {
																					...item,
																					imprime_relatorio: !item.imprime_relatorio
																				}
																			} else {
																				return item;
																			}
																		})
																	}
																});
															}} />
													</div>}

													{(false && pergunta.imagem) ? ( //Se tem imagem não mostra campo pra digitação
														<div />
													) : (pergunta.id_tipo == 1 ? ( //text Curto
														<div>
															<LabelAndInput
																mode='outlined'
																placeholder='Digite aqui...'
																value={resposta.resposta}
																style={textInput}
																onChange={text => {
																	atualizarSimples(text.target.value);
																}} />
														</div>
													) : (pergunta.id_tipo == 2 ? ( //texto Longo
														<div>
															<LabelAndTextarea
																mode='outlined'
																placeholder='Digite aqui...'
																value={resposta.resposta}
																style={textInput}
																rows={3}
																onChange={text => {
																	atualizarSimples(text.target.value);
																}} />
														</div>
													) : (pergunta.id_tipo == 3 ? ( //Data
														<div>
															
															<LabelAndInput
																mode='outlined'
																placeholder='Digite aqui...'
																value={(resposta.resposta || '').split('/').join('-').split('T')[0]}
																style={textInput}
																widthComponent={150}
																type={'date'}
																onChange={text => {
																	atualizarSimples(text.target.value);
																}} />
														</div>
													) : (pergunta.id_tipo == 4 ? ( //Numérica
														<div>
															<LabelAndInput
																mode='outlined'
																placeholder='Digite aqui...'
																keyboardType='numeric'
																value={(resposta.resposta || '').replace('.', ',')}
																style={textInput}
																casas={2}
																onChange={text => {
																	atualizarSimples((text.target.value || '').replace(',', '.').replace(/[a-zA-Z]/g, ''));
																}} />
														</div>
													) : (pergunta.id_tipo == 5 ? ( //Lista de Seleção Única
														<div style={{ marginTop: 4 }}>
															{(pergunta.opcoes || []).map(opcao => (
															<LabelAndRadioButtom key={opcao.id}
																style={{ font }}
																marginBottomComponent={0}
																label={opcao.nome}
																value={opcao.id == resposta.resposta}
																onChange={() => atualizarSimples(opcao.id)} />
															))}
														</div>
													) : (pergunta.id_tipo == 6 ? ( //Lista de Seleção Múltipla
														<div style={{ marginTop: 4 }}>
															{(pergunta.opcoes || []).map(opcao => (
															<LabelAndCheckbox key={opcao.id}
																style={{ font }}
																marginBottomComponent={0}
																label={opcao.nome}
																value={(resposta.resposta || []).includes(opcao.id)}
																onChange={() => atualizarMulti(opcao.id)} />
															))}
														</div>
													) : (pergunta.id_tipo == 7 ? ( //Avaliativa
														<div style={{ marginTop: 4 }}>
															{[
																{ id: 'sim', nome: 'Sim' },
																{ id: 'nao', nome: 'Não' }
															].map(opcao => (
															<LabelAndRadioButtom key={opcao.id}
																style={{ font }}
																marginBottomComponent={0}
																label={opcao.nome}
																value={opcao.id == resposta.resposta}
																onChange={() => atualizarSimples(opcao.id)} />
															))}
														</div>
													) : (pergunta.id_tipo == 9 ? ( //Pergunta com dependentes
														<div style={{ marginTop: 4 }}>
															{[
																{ id: 'Sim', nome: pergunta.dependente_condicao_1 || 'Sim' },
																{ id: 'Não', nome: pergunta.dependente_condicao_2 || 'Não' }
															].map(opcao => (
															<LabelAndRadioButtom key={opcao.id}
																style={{ font }}
																marginBottomComponent={0}
																label={opcao.nome}
																value={opcao.id == resposta.resposta}
																onChange={() => atualizarSimples(opcao.id)} />
															))}
														</div>
													 ) : (pergunta.id_tipo == 10 ? ( //Hora
														<div>
															<LabelAndInputMask
																mode='outlined'
																placeholder='00:00'
																keyboardType='numeric'
																value={(resposta.resposta || '').replace('.', ',')}
																style={textInput}
																widthComponent={150}
																mask={'99:99'}
																onChange={text => {
																	atualizarSimples((text.target.value || ''));
																}} />
														</div>
													) : null)))))))))}

													{this.componenteComentario(resposta, pergunta)}
													{this.componenteFoto(resposta, pergunta)}
													{this.componenteAnexo(resposta, pergunta)}
													{this.componenteAssinatura(resposta, pergunta)}

												</div>
												
											);
										})}
									</div>
								</div>
							)
						})}

					</ContentCardBody>
					<ContentCardFooter>

						<Row alignCenter>
							<Grid cols='3 3 3 3'>
								<Button
									type={'primary'}
									text={'Ir ao Início'}
									style={{ ...buttonCadastroAcaoPrimary, ...styles.buttonAcao }}
									event={() => {
										window.scrollTo({ top: 0, behavior: 'smooth' });
										// window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
									}} />
							</Grid>
							{anterior && (
								<Grid cols='3 3 3 3'>
									<Button 
										type={'primary'}
										text={'Anterior'}
										style={{ ...buttonCadastroAcaoPrimary, ...styles.buttonAcao }}
										event={() => {
											if (this.validarRespostas(listaArea.filter(area => area.posicaoArea == this.state.posicaoArea))) {
												this.salvarRespostas(listaArea.filter(area => area.posicaoArea == this.state.posicaoArea));
												this.setState({
													...this.state,
													posicaoArea: this.state.posicaoArea - 1
												});
											}
										}} />
								</Grid>
							)}
							{proximo ? (
								<Grid cols='3 3 3 3'>
									<Button
										type={'primary'}
										text={'Próxima'}
										style={{ ...buttonCadastroAcaoPrimary, ...styles.buttonAcao }}
										event={() => {
											if (this.validarRespostas(listaArea.filter(area => area.posicaoArea == this.state.posicaoArea))) {
												this.salvarRespostas(listaArea.filter(area => area.posicaoArea == this.state.posicaoArea));
												this.setState({
													...this.state,
													posicaoArea: this.state.posicaoArea + 1
												});
											}
										}} />
								</Grid>
							) : (
								<>
									<Grid cols='3 3 3 3'>
										<Button 
											type={'success'} 
											text={'Salvar'}
											style={{ ...buttonCadastroAcaoPrimary, ...styles.buttonAcao }}
											event={() => {
												if (this.validarRespostas(listaArea.filter(area => area.posicaoArea == this.state.posicaoArea))) {
													this.salvarRespostas(listaArea.filter(area => area.posicaoArea == this.state.posicaoArea), true);
													this.props.setModoTela('lista')
												}
											}} />
									</Grid>
									<Grid cols='3 3 3 3'>
										<Button 
											type={'success'} 
											text={'Concluir'}
											style={{ ...buttonCadastroAcaoPrimary, ...styles.buttonAcao }}
											event={() => {
												if (this.validarRespostas(listaArea.filter(area => area.posicaoArea == this.state.posicaoArea))) {
													this.salvarRespostas(listaArea.filter(area => area.posicaoArea == this.state.posicaoArea), true, true);
													this.props.setModoTela('lista')
												}
											}} />
									</Grid>
								</>
							)}
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }

	componenteComentario(resposta, pergunta) {

		const colors = {
			background: '#fff',
			backgroundFont: '#1e0805',
			primary: '#231f20',
			primaryDark: '#030303',
			primaryFont: '#fff',
			accent: '#f57215',
			accentLight: '#fa9e5c',
			accentFont: '#fff',
			font: '#03260f',
			danger: '#d32f2f'
		};
		const font = {
			color: colors.font,
			fontSize: 16
		};
		const textInput = {
			color: colors.backgroundFont,
			backgroundColor: colors.background,
			marginBottom: 12
		};

		if (!pergunta || !pergunta.complemento_comentario) {
			return null;
		}

		return (
			<div>
				<div style={{ ...font }}>Comentário</div>
				<LabelAndTextarea
					mode='outlined'
					placeholder='Digite aqui...'
					value={resposta.complemento_comentario}
					style={textInput}
					rows={3}
					theme={{
						colors: {
							placeholder: textInput.color,
							text: textInput.color,
							primary: textInput.color,
							underlineColor: textInput.color,
							background: textInput.backgroundColor
						}
					}}
					onChange={text => {
						this.setState({
							...this.state,
							checklistResposta: {
								...this.state.checklistResposta,
								itens: this.state.checklistResposta.itens.map(item => {
									if (item.id == resposta.id) {
										return {
											...item,
											complemento_comentario: text.target.value
										}
									} else {
										return item;
									}
								})
							}
						});
					}} />
			</div>
		);

	}

	componenteFoto(resposta, pergunta) {

		const colors = {
			background: '#fff',
			backgroundFont: '#1e0805',
			primary: '#231f20',
			primaryDark: '#030303',
			primaryFont: '#fff',
			accent: '#f57215',
			accentLight: '#fa9e5c',
			accentFont: '#fff',
			font: '#03260f',
			danger: '#d32f2f'
		};
		const font = {
			color: colors.font,
			fontSize: 16
		};
		const textInput = {
			color: colors.backgroundFont,
			backgroundColor: colors.background,
			marginBottom: 12
		};
		const buttonCadastroExcluir = {
			flex: 2,
			backgroundColor: colors.danger,
			color: colors.font,
			marginTop: 12
		};
			
		if (!pergunta || !pergunta.complemento_foto) {
			return null;
		}

		return (
			<div>
				<div style={{ ...font }}>Foto</div>

				<div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginBottom: 16 }}>
					{(resposta.complemento_registro_fotos || []).filter(foto => foto).map((foto, posImagem) => (
					
						<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', backgroundColor: '#d9d9d9', padding: 8, width: 300 }}>
							
							<img
								style={{ width: 284 }}
								src={foto.base64} />

							<div>
								<input 
									className='form-control'
									style={{
										marginTop: 8,
										marginBottom: 0
									}}
									mode='outlined'
									placeholder='Legenda'
									value={foto.legenda}
									onChange={text => {
										this.setState({
											...this.state,
											checklistResposta: {
												...this.state.checklistResposta,
												itens: this.state.checklistResposta.itens.map(item => {
													if (item.id == resposta.id) {
														return {
															...item,
															complemento_registro_fotos: item.complemento_registro_fotos.filter(itemFoto => itemFoto).map(fotoAux => {
																if (fotoAux.id == foto.id) {
																	return {
																		...fotoAux,
																		legenda: text.target.value
																	};
																} else {
																	return fotoAux;
																}
															})
														}
													} else {
														return item;
													}
												})
											}
										});
									}} />

								<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
									<button 
										type='button' 
										class='btn btn-primary btn-block btn-sm'
										style={{ 
											width: 50,
											marginLeft: 0,
											marginTop: 8
										}}
										onClick={() => {
											

											this.setState({
												...this.state,
												checklistResposta: {
													...this.state.checklistResposta,
													itens: this.state.checklistResposta.itens.map(item => {
														
														let listaOrdenada = (item.complemento_registro_fotos || []).map(fotoAux => ({ ...fotoAux }));

														if ((item.complemento_registro_fotos || [])[posImagem - 1]) {
															listaOrdenada[posImagem] = (item.complemento_registro_fotos || [])[posImagem - 1];
															listaOrdenada[posImagem - 1] = (item.complemento_registro_fotos || [])[posImagem];
														}

														if (item.id == resposta.id) {
															return {
																...item,
																complemento_registro_fotos: listaOrdenada
															}
														} else {
															return item;
														}
													})
												}
											});
										}}>
										<i class='fa fa-chevron-left'></i>
									</button>

									<button 
										type='button' 
										class='btn btn-primary btn-block btn-sm'
										style={{ 
											width: 50,
											marginTop: 8
										}}
										onClick={() => {
											

											this.setState({
												...this.state,
												checklistResposta: {
													...this.state.checklistResposta,
													itens: this.state.checklistResposta.itens.map(item => {
														
														let listaOrdenada = (item.complemento_registro_fotos || []).map(fotoAux => ({ ...fotoAux }));

														if ((item.complemento_registro_fotos || [])[posImagem + 1]) {
															listaOrdenada[posImagem] = (item.complemento_registro_fotos || [])[posImagem + 1];
															listaOrdenada[posImagem + 1] = (item.complemento_registro_fotos || [])[posImagem];
														}

														if (item.id == resposta.id) {
															return {
																...item,
																complemento_registro_fotos: listaOrdenada
															}
														} else {
															return item;
														}
													})
												}
											});
										}}>
										<i class='fa fa-chevron-right'></i>
									</button>

									<button 
										type='button' 
										class='btn btn-danger btn-block btn-sm'
										style={{ 
											width: 50,
											marginTop: 8
										}}
										onClick={() => {
											this.setState({
												...this.state,
												checklistResposta: {
													...this.state.checklistResposta,
													itens: this.state.checklistResposta.itens.map(item => {
														if (item.id == resposta.id) {
															return {
																...item,
																complemento_registro_fotos: item.complemento_registro_fotos.filter(itemFoto => itemFoto && itemFoto.id != foto.id)
															}
														} else {
															return item;
														}
													})
												}
											});
										}}>
										<i class='fa fa-trash'></i>
									</button>

									<button 
										type='button' 
										class='btn btn-primary btn-block btn-sm'
										style={{
											width: 50,
											marginTop: 8
										}}
										onClick={() => {
											this.setFotoExpandida(foto.base64);
										}}>
										<i class='fa fa-expand'></i>
									</button>
								</div>
							</div>
						</div>

					))}
						
					<div>
						<a class='btn btn-app bg-success'
							onClick={() => {
								this.setState({ 
									...this.state, 
									funcaoSalvarFile: (imagens) => {
										this.setState({
											...this.state,
											checklistResposta: {
												...this.state.checklistResposta,
												itens: this.state.checklistResposta.itens.map(item => {
													if (item.id == resposta.id) {
														let complementoFoto = (item.complemento_registro_fotos || []);
														imagens.forEach((imagem, i) => {
															complementoFoto.push({
																id: `${String(new Date().getTime())}${i}`,
																base64: imagem,
																legenda: ''
															});
														});
														return {
															...item,
															complemento_registro_fotos: complementoFoto
														}
													} else {
														return item;
													}
												})
											},
											eventoAbrirCamera: null
										});
									} 
								});
								this.imageSelector.click()
							}}>
							<i class='fas fa-camera'></i> Adicionar
						</a>
					</div>
				</div>
			</div>
		);

	}

	setFotoExpandida(base64) {
		this.setState({
			...this.state,
			fotoExpandida: base64
		});
	}
	
	fotoExpandida() {

		if (!this.state.fotoExpandida) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl' style={{ minWidth: '90%' }}>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'></h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setFotoExpandida(null)}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight * 0.8, overflowY: 'scroll' }}>
							<ImagemZoom src={this.state.fotoExpandida} alt='' />
						</div>
					</div>
				</div>
			</div>
        );
    }

	componenteAnexo(resposta, pergunta) {

		const colors = {
			background: '#fff',
			backgroundFont: '#1e0805',
			primary: '#231f20',
			primaryDark: '#030303',
			primaryFont: '#fff',
			accent: '#f57215',
			accentLight: '#fa9e5c',
			accentFont: '#fff',
			font: '#03260f',
			danger: '#d32f2f'
		};
		const font = {
			color: colors.font,
			fontSize: 16
		};
		const textInput = {
			color: colors.backgroundFont,
			backgroundColor: colors.background,
			marginBottom: 12
		};
		const buttonCadastroExcluir = {
			flex: 2,
			backgroundColor: colors.danger,
			color: colors.font,
			marginTop: 12
		};

		if (!pergunta || !pergunta.complemento_anexo) {
			return null;
		}

		return (
			<div>
				<div style={{ ...font }}>Anexo</div>

				<div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
					{(resposta.complemento_anexos || []).map((anexo, posAnexo) => (

						<div key={anexo} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#d9d9d9', padding: 8, width: 300 }}>
							<img
								style={{ width: 30, height: 40 }}
								src={pdfAdicionado} />

							<input 
								className='form-control'
								style={{
									marginTop: 8,
									marginBottom: 0
								}}
								mode='outlined'
								placeholder='Legenda'
								value={anexo.legenda}
								onChange={text => {
									this.setState({
										...this.state,
										checklistResposta: {
											...this.state.checklistResposta,
											itens: this.state.checklistResposta.itens.map(item => {
												if (item.id == resposta.id) {
													return {
														...item,
														complemento_anexos: item.complemento_anexos.filter(itemAnexo => itemAnexo).map(anexoAux => {
															if (anexoAux.id == anexo.id) {
																return {
																	...anexoAux,
																	legenda: text.target.value
																};
															} else {
																return anexoAux;
															}
														})
													}
												} else {
													return item;
												}
											})
										}
									});
								}} />

							<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
								<button 
									type='button' 
									class='btn btn-primary btn-block btn-sm'
									style={{ 
										width: 50,
										marginLeft: 0,
										marginTop: 8
									}}
									onClick={() => {
										this.setState({
											...this.state,
											checklistResposta: {
												...this.state.checklistResposta,
												itens: this.state.checklistResposta.itens.map(item => {
													
													let listaOrdenada = (item.complemento_anexos || []).map(anexoAux => ({ ...anexoAux }));
														
													if ((item.complemento_anexos || [])[posAnexo - 1]) {
														listaOrdenada[posAnexo] = (item.complemento_anexos || [])[posAnexo - 1];
														listaOrdenada[posAnexo - 1] = (item.complemento_anexos || [])[posAnexo];
													}

													if (item.id == resposta.id) {
														return {
															...item,
															complemento_anexos: listaOrdenada
														}
													} else {
														return item;
													}
												})
											}
										});
									}}>
									<i class='fa fa-chevron-left'></i>
								</button>

								<button 
									type='button' 
									class='btn btn-primary btn-block btn-sm'
									style={{ 
										width: 50,
										marginTop: 8
									}}
									onClick={() => {									
										this.setState({
											...this.state,
											checklistResposta: {
												...this.state.checklistResposta,
												itens: this.state.checklistResposta.itens.map(item => {
													
													let listaOrdenada = (item.complemento_anexos || []).map(anexoAux => ({ ...anexoAux }));
													
													if ((item.complemento_anexos || [])[posAnexo + 1]) {
														listaOrdenada[posAnexo] = (item.complemento_anexos || [])[posAnexo + 1];
														listaOrdenada[posAnexo + 1] = (item.complemento_anexos || [])[posAnexo];
													}
													
													if (item.id == resposta.id) {
														return {
															...item,
															complemento_anexos: listaOrdenada
														}
													} else {
														return item;
													}
												})
											}
										});
									}}>
									<i class='fa fa-chevron-right'></i>
								</button>

								<button 
									type='button' 
									class='btn btn-danger btn-block btn-sm'
									style={{
										width: 50,
										marginTop: 8
									}}
									onClick={() => {
										this.setState({
											...this.state,
											checklistResposta: {
												...this.state.checklistResposta,
												itens: this.state.checklistResposta.itens.map(item => {
													if (item.id == resposta.id) {
														return {
															...item,
															complemento_anexos: item.complemento_anexos.filter(itemAnexo => itemAnexo != anexo)
														}
													} else {
														return item;
													}
												})
											}
										});
									}}>
									<i class='fa fa-trash'></i>
								</button>
								<button 
									type='button' 
									class='btn btn-primary btn-block btn-sm'
									style={{
										width: 50,
										marginTop: 8
									}}
									onClick={() => {
										const mimeType = anexo.base64.split(';')[0].split(':')[1] || '';
										
										let filename = 'anexo.';

										switch (mimeType) {
											case 'application/pdf':
												filename += 'pdf';
												break;
											case 'image/png':
												filename += 'png';
												break;
											case 'image/jpg': 
											filename += 'jpg';
											break;
											case 'image/jpeg':
												filename += 'jpeg';
												break;
											case 'video/mp4':
												filename += 'mp4';
												break;
											case 'video/avi':
												filename += 'avi';
												break;
											case 'video/mpeg':
												filename += 'mpeg';
												break;
											case 'video/quicktime':
												filename += 'mov';
												break;
											case 'application/vnd.ms-excel': // .xls
												filename += 'xls';
												break;
											case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': // .xlsx
												filename += 'xlsx';
												break;
											case 'application/msword': // .doc
												filename += 'docx';
												break;
											case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': // .docx
												filename += 'pdf';
												break;
											case 'application/vnd.ms-powerpoint': // .ppt
												filename += 'ppt';
												break;
											case 'application/vnd.openxmlformats-officedocument.presentationml.presentation': // .pptx
												filename += 'pptx';
												break;

											default:
												filename += 'pdf';
										}
										
										const link = document.createElement('a');
										link.href = anexo.base64;
										link.download = filename;
										document.body.appendChild(link);
										link.click();
										document.body.removeChild(link);
									}}>
									<i class='fa fa-download'></i>
								</button>
							</div>
						</div>
					))}
				
					<div>
						<a class='btn btn-app bg-success'
							onClick={() => {
								this.setState({ 
									...this.state, 
									funcaoSalvarFile: (anexos) => {
										this.setState({
											...this.state,
											checklistResposta: {
												...this.state.checklistResposta,
												itens: this.state.checklistResposta.itens.map(item => {
													if (item.id == resposta.id) {
														let complementoAnexo = (item.complemento_anexos || []);
														anexos.forEach((anexo, i) => {
															complementoAnexo.push({
																id: `${String(new Date().getTime())}${i}`,
																base64: anexo,
																legenda: ''
															});
														});
														return {
															...item,
															complemento_anexos: complementoAnexo
														};
													} else {
														return item;
													}
												})
											},
											eventoAbrirCamera: null
										});
									} 
								});
								this.fileSelector.click()
							}}>
							<i class='fas fa-paperclip'></i> Adicionar
						</a>
					</div>
					
				</div>

			</div>
		);

	}

	componenteAssinatura(resposta, pergunta) {

		const colors = {
			background: '#fff',
			backgroundFont: '#1e0805',
			primary: '#231f20',
			primaryDark: '#030303',
			primaryFont: '#fff',
			accent: '#f57215',
			accentLight: '#fa9e5c',
			accentFont: '#fff',
			font: '#03260f',
			danger: '#d32f2f'
		};
		const font = {
			color: colors.font,
			fontSize: 16
		};
		const textInput = {
			color: colors.backgroundFont,
			backgroundColor: colors.background,
			marginBottom: 12
		};

		if (!pergunta || !pergunta.complemento_assinatura) {
			return null;
		}
		
		return (
			<div>

				{Array.from(Array(pergunta.quantidade_assinatura || 1).keys()).map(posicao => {

					let assinaturaAtual = (resposta.complemento_assinatura || []).filter(itemAssinatura => itemAssinatura.id == posicao + 1)[0];

					return (
						<div key={posicao}>
							<InputAssinatura
								idUploadAssinatura={`inputAssinatura_${pergunta.id}_${resposta.id}_${posicao + 1}`}
								label={`Assinatura ${posicao + 1}`}
								value={assinaturaAtual ? assinaturaAtual.assinatura : null}
								onChange={(assinatura) => {
									this.setState({
										...this.state,
										checklistResposta: {
											...this.state.checklistResposta,
											itens: this.state.checklistResposta.itens.map(item => {
												if (item.id == resposta.id) {
													let complementoAssinaturas = (item.complemento_assinatura || []).filter(itemAssinatura => itemAssinatura.id != posicao + 1);
													
													complementoAssinaturas.push({
														id: posicao + 1,
														assinatura: assinatura ? assinatura : null,
														nome: assinaturaAtual ? assinaturaAtual.nome : '',
														cargo: assinaturaAtual ? assinaturaAtual.cargo : ''
													});
													
													return {
														...item,
														complemento_assinatura: complementoAssinaturas
													};
												} else {
													return item;
												}
											})
										},
										eventoAbrirCamera: null
									});
								}} />

							{assinaturaAtual &&
							<div
								style={{
									width: window.innerWidth < 500 ? window.innerWidth - 10 : 500,
									display: 'flex',
									flexDirection: 'row'
								}}>
								<LabelAndInput
									cols='8 8 8 8'
									mode='outlined'
									placeholder='Nome'
									value={assinaturaAtual.nome}
									style={textInput}
									onChange={text => {
										this.setState({
											...this.state,
											checklistResposta: {
												...this.state.checklistResposta,
												itens: this.state.checklistResposta.itens.map(item => {
													if (item.id == resposta.id) {
														let complementoAssinaturas = (item.complemento_assinatura || []).filter(itemAssinatura => itemAssinatura.id != posicao + 1);
														
														complementoAssinaturas.push({
															id: posicao + 1,
															assinatura: assinaturaAtual.assinatura ? assinaturaAtual.assinatura : null,
															nome: text.target.value,
															cargo: assinaturaAtual ? assinaturaAtual.cargo : ''
														});
														
														return {
															...item,
															complemento_assinatura: complementoAssinaturas
														};
													} else {
														return item;
													}
												})
											}
										});
									}} />

								<LabelAndInput
									cols='4 4 4 4'
									mode='outlined'
									placeholder='Cargo'
									value={assinaturaAtual.cargo}
									style={textInput}
									onChange={text => {
										this.setState({
											...this.state,
											checklistResposta: {
												...this.state.checklistResposta,
												itens: this.state.checklistResposta.itens.map(item => {
													if (item.id == resposta.id) {
														let complementoAssinaturas = (item.complemento_assinatura || []).filter(itemAssinatura => itemAssinatura.id != posicao + 1);
														
														complementoAssinaturas.push({
															id: posicao + 1,
															assinatura: assinaturaAtual ? assinaturaAtual.assinatura : null,
															nome: assinaturaAtual ? assinaturaAtual.nome : '',
															cargo: text.target.value
														});
														
														return {
															...item,
															complemento_assinatura: complementoAssinaturas
														};
													} else {
														return item;
													}
												})
											}
										});
									}} />
							</div>}
						</div>
					)})}
			</div>
		);

	}

	validarRespostas(areas) {

		let erroObrigatorio = false;
		areas.forEach(area => {
			this.props.listaPergunta.filter(pergunta => pergunta.id_area == area.id).forEach(pergunta => {
				
				let resposta = (this.state.checklistResposta ? this.state.checklistResposta.itens : []).filter(itemResposta => itemResposta.id_item == pergunta.id)[0];
				
				if (resposta && !erroObrigatorio && pergunta.obrigatorio && !pergunta.id_pai) {
					if (pergunta.id_tipo == 1) { //testo Curto
						erroObrigatorio = (resposta.resposta || '').length <= 0;					
					} else if (pergunta.id_tipo == 2) { //testo Longo
						erroObrigatorio = (resposta.resposta || '').length <= 0;
					} else if (pergunta.id_tipo == 3) { //Data
						erroObrigatorio = (resposta.resposta || '').length <= 0;
					} else if (pergunta.id_tipo == 4) { //Numérica
						erroObrigatorio = (resposta.resposta || '').length <= 0;
					} else if (pergunta.id_tipo == 5) { //Lista de Seleção Única
						erroObrigatorio = (resposta.resposta || '').length <= 0;
					} else if (pergunta.id_tipo == 6) { //Lista de Seleção Múltipla
						erroObrigatorio = (resposta.resposta || []).length <= 0;
					} else if (pergunta.id_tipo == 7) { //Avaliativa
						erroObrigatorio = (resposta.resposta || '').length <= 0;
					} else if (pergunta.id_tipo == 9) { //Pergunta com Dependentes
						erroObrigatorio = (resposta.resposta || '').length <= 0;
					} else if (pergunta.id_tipo == 10) { //Hora
						erroObrigatorio = (resposta.resposta || '').length < 5;
					}
				}
			});
		});

		if (erroObrigatorio) {
			
			setError('Responda as perguntas obrigatórias (*)');
			
		}

		return !erroObrigatorio;

	}

	salvarRespostas(areas, ultima, concluir) {
		areas.forEach(area => {
			this.props.listaPergunta.filter(pergunta => pergunta.id_area == area.id).forEach(pergunta => {
				
				let resposta = (this.state.checklistResposta ? this.state.checklistResposta.itens : []).filter(itemResposta => itemResposta.id_item == pergunta.id)[0];
				if (resposta) {
					this.props.salvarCheklistResposta(resposta);
				}
			});
		});

		if (ultima) {
			
			let gestor = this.props.sessao.id_perfil == 1 || this.props.sessao.id_perfil == 7;

			this.props.salvarCheklistStatus({
				...this.state.checklistResposta,
				itens: null,
				id_status: concluir ? 3 : 2
			});

			if (this.props.formularioValues.eventoAtualizarRelatorio) {
				this.props.formularioValues.eventoAtualizarRelatorio();
			}
		}
													
	}

}

ChecklistRespostaForm = reduxForm({form: 'checklistRespostaForm', destroyOnUnmount: false})(ChecklistRespostaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('checklistRespostaForm')(state),
	listaArea: state.checklistResposta.listaArea,
	listaPergunta: state.checklistResposta.listaPergunta
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, getListaArea, getListaPergunta, salvarCheklistResposta, salvarCheklistStatus
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ChecklistRespostaForm);
